import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Card} from '@jobseeker/lotus/components';
import {Paragraph} from '@jobseeker/lotus/elements';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/stores';

const EpochTermsPage = () => {
  const {
    timelines: {
      config: {termsAndConditions},
    },
  } = useSelector((state: AppState) => state.competition);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card variant="" heading="">
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 500,
            textAlign: 'Center',
            color: 'secondary.dark',
          }}
        >
          TERMS AND CONDITIONS
        </Typography>
        <Paragraph
          title=""
          body={
            <>
              <ol style={{lineHeight: '32px'}}>
                {termsAndConditions?.map((item: string, index: number) => (
                  <li key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                ))}
              </ol>
            </>
          }
        />
      </Card>
    </Box>
  );
};

export default EpochTermsPage;
